import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCompanyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#222426"
      d="M19.445 3.571h-5.556V.714a.83.83 0 0 0-.162-.505.502.502 0 0 0-.394-.209H6.667C6.36 0 6.11.32 6.11.714v2.857H.556c-.307 0-.556.32-.556.715v15c0 .19.058.371.162.505A.502.502 0 0 0 .556 20h18.889a.502.502 0 0 0 .393-.209.83.83 0 0 0 .162-.505v-15a.83.83 0 0 0-.162-.506.502.502 0 0 0-.393-.209ZM7.222 1.43h5.556V3.57H7.222V1.43Zm11.667 8.62L10 13.02l-8.889-2.97V5H18.89v5.05Zm-7.222-1.027a.83.83 0 0 1-.163.506.502.502 0 0 1-.393.209H8.89c-.307 0-.556-.32-.556-.715 0-.394.25-.714.556-.714h2.222c.148 0 .29.076.393.21a.829.829 0 0 1 .163.504Z"
    />
  </svg>
);
export default SvgCompanyIcon;
